import { Modal, Skeleton, Tabs } from "antd";
import { useEffect, useState } from "react";
import type { TabsProps } from "antd";
import { RecordStatus, RequestConnection } from "../../../..";
import { useSelector } from "react-redux";
import Connections from "./Connections";
import store from "../../../../../controllers/store";
import { getReceived } from "../../../../../controllers/store/actions/connection/connection-received-actions";
import { getSended } from "../../../../../controllers/store/actions/connection/connection-sended-actions";

type PaginationPosition = "top" | "bottom" | "both";
type PaginationAlign = "start" | "center" | "end";

interface Props {
  sended: RequestConnection[];
  received: RequestConnection[];
  onOk: (value: any) => void;
  open: boolean;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const ConnectionRequestList = (props: Props) => {
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  const received = useSelector((state: any) => {
    return state.received;
  });

  const sendeds = useSelector((state: any) => {
    return state.sendeds;
  });

  const [position, setPosition] = useState<PaginationPosition>("bottom");
  const [align, setAlign] = useState<PaginationAlign>("center");
  const [value, setValue] = useState("");
  const [loading, setIsloading] = useState(false);
  useEffect(() => {
    if (user) {
      dispatch(
        getReceived(
          "connection_request",
          {
            meta: "filter_count",
            filter: `&filter[owner_email][_eq]=${user.me.email}&filter[status][_eq]=${RecordStatus.Active}`,
          },
          1,
          10
        )
      );
      dispatch(
        getSended(
          "connection_request",
          {
            meta: "filter_count",
            filter: `&filter[user_created][id][_eq]=${user.me.id}&filter[status][_eq]=${RecordStatus.Active}`,
          },
          1,
          10
        )
      );
    }
  }, [user, props.open]);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Enviadas (${sendeds.data.pagination?.total})`,
      children: (
        <Connections
          pagination={sendeds.data.pagination}
          type="sended"
          values={sendeds.data.values}
        />
      ),
    },
    {
      key: "2",
      label: `Recibidas (${received.data.pagination?.total})`,
      children: (
        <Connections
          pagination={received.data.pagination}
          type="received"
          values={received.data.values}
        />
      ),
    },
  ];

  const handleOk = () => {
    props.onOk(value);
  };

  const handleCancel = () => {
    props.onCancel();
  };

  return (
    <Modal
      cancelText={"Cancelar"}
      okText="Ok"
      title="Mis conexiones"
      open={props.open}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Skeleton loading={loading} active className="full-width">
        <Tabs defaultActiveKey="1" items={items} />
      </Skeleton>
    </Modal>
  );
};

export default ConnectionRequestList;
